// extracted by mini-css-extract-plugin
export var badge = "_ge-2";
export var detailsPanel = "_ge-0";
export var resultRow = "_ge-1";